<template>
  <label>
    <input type="checkbox" v-model="modelValue" />
    {{ modelValue ? t('sconai_logo_visible') : t('sconai_logo_invisible') }}
  </label>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { useUserStore } from '@/stores/user';

const userStore = useUserStore();

const props = withDefaults(defineProps<{ isGlobal: boolean }>(), {
  isGlobal: false,
});

const { t } = useI18n();

const modelValue = defineModel<boolean>({
  default: true,
  set(newVal) {
    if (props.isGlobal) {
      userStore.updateUserPreferences({ setting: 'subtitleIsVisibleLogo', newVal });
    }

    return newVal;
  },
});
</script>

<style scoped lang="scss">
label {
  color: var(--font-default);
}
</style>
